export const CAMPAIGN_DRAFT_AGENT_ID = 'campaign_draft_agent_id';

// TODO - remove once MS voices are fully deprecated
export const MS_DEPRECATED_VOICES_MAP: { [oldVoiceId: string]: string } = {
    'ar-EG-Hoda': 'ar-EG-SalmaNeural',
    'ar-SA-Naayf': 'ar-SA-HamedNeural',
    'bg-BG-Ivan': 'bg-BG-BorislavNeural',
    'ca-ES-HerenaRUS': 'ca-ES-JoanaNeural',
    'zh-HK-Danny': 'zh-HK-WanLungNeural',
    'zh-HK-TracyRUS': 'zh-HK-HiuMaanNeural',
    'zh-CN-HuihuiRUS': 'zh-CN-XiaoxiaoNeural',
    'zh-CN-Kangkang': 'zh-CN-YunxiNeural',
    'zh-CN-Yaoyao': 'zh-CN-XiaoxiaoNeural',
    'zh-TW-HanHanRUS': 'zh-TW-HsiaoChenNeural',
    'zh-TW-Yating': 'zh-TW-HsiaoChenNeural',
    'zh-TW-Zhiwei': 'zh-TW-YunJheNeural',
    'hr-HR-Matej': 'hr-HR-SreckoNeural',
    'cs-CZ-Jakub': 'cs-CZ-AntoninNeural',
    'da-DK-HelleRUS': 'da-DK-ChristelNeural',
    'nl-NL-HannaRUS': 'nl-NL-FennaNeural',
    'en-AU-Catherine': 'en-AU-NatashaNeural',
    'en-AU-HayleyRUS': 'en-AU-NatashaNeural',
    'en-CA-HeatherRUS': 'en-CA-ClaraNeural',
    'en-CA-Linda': 'en-CA-ClaraNeural',
    'en-IN-Heera': 'en-IN-NeerjaNeural1',
    'en-IN-PriyaRUS': 'en-IN-NeerjaNeural1',
    'en-IN-Ravi': 'en-IN-PrabhatNeural',
    'en-IE-Sean': 'en-IE-ConnorNeural',
    'en-GB-George': 'en-GB-RyanNeural',
    'en-GB-HazelRUS': 'en-GB-SoniaNeural',
    'en-GB-Susan': 'en-GB-SoniaNeural',
    'en-US-BenjaminRUS': 'en-US-GuyNeural',
    'en-US-GuyRUS': 'en-US-GuyNeural',
    'en-US-AriaRUS': 'en-US-AriaNeural',
    'en-US-ZiraRUS': 'en-US-AriaNeural',
    'fi-FI-HeidiRUS': 'fi-FI-SelmaNeural',
    'fr-CA-Caroline': 'fr-CA-SylvieNeural',
    'fr-CA-HarmonieRUS': 'fr-CA-SylvieNeural',
    'fr-FR-HortenseRUS': 'fr-FR-DeniseNeural',
    'fr-FR-Julie': 'fr-FR-DeniseNeural',
    'fr-FR-Paul': 'fr-FR-HenriNeural',
    'fr-CH-Guillaume': 'fr-CH-FabriceNeural',
    'de-AT-Michael': 'de-AT-JonasNeural',
    'de-DE-HeddaRUS': 'de-DE-KatjaNeural',
    'de-DE-Stefan': 'de-DE-ConradNeural',
    'de-CH-Karsten': 'de-CH-JanNeural',
    'el-GR-Stefanos': 'el-GR-NestorasNeural',
    'he-IL-Asaf': 'he-IL-AvriNeural',
    'hi-IN-Hemant': 'hi-IN-MadhurNeural',
    'hi-IN-Kalpana': 'hi-IN-SwaraNeural1',
    'hu-HU-Szabolcs': 'hu-HU-TamasNeural',
    'id-ID-Andika': 'id-ID-ArdiNeural',
    'it-IT-Cosimo': 'it-IT-DiegoNeural',
    'it-IT-LuciaRUS': 'it-IT-IsabellaNeural',
    'ja-JP-Ayumi': 'ja-JP-NanamiNeural',
    'ja-JP-HarukaRUS': 'ja-JP-NanamiNeural',
    'ja-JP-Ichiro': 'ja-JP-KeitaNeural',
    'ko-KR-HeamiRUS': 'ko-KR-SunHiNeural',
    'ms-MY-Rizwan': 'ms-MY-OsmanNeural',
    'nb-NO-HuldaRUS': 'nb-NO-PernilleNeural',
    'pl-PL-PaulinaRUS': 'pl-PL-AgnieszkaNeural',
    'pt-BR-Daniel': 'pt-BR-AntonioNeural',
    'pt-BR-HeloisaRUS': 'pt-BR-FranciscaNeural',
    'pt-PT-HeliaRUS': 'pt-PT-RaquelNeural',
    'ro-RO-Andrei': 'ro-RO-EmilNeural',
    'ru-RU-EkaterinaRUS': 'ru-RU-SvetlanaNeural',
    'ru-RU-Irina': 'ru-RU-DariyaNeural',
    'ru-RU-Pavel': 'ru-RU-DmitryNeural',
    'sk-SK-Filip': 'sk-SK-LukasNeural',
    'sl-SI-Lado': 'sl-SI-RokNeural',
    'es-MX-HildaRUS': 'es-MX-DaliaNeural',
    'es-MX-Raul': 'es-MX-JorgeNeural',
    'es-ES-HelenaRUS': 'es-ES-ElviraNeural',
    'es-ES-Laura': 'es-ES-ElviraNeural',
    'es-ES-Pablo': 'es-ES-AlvaroNeural',
    'sv-SE-HedvigRUS': 'sv-SE-SofieNeural',
    'ta-IN-Valluvar': 'ta-IN-ValluvarNeural',
    'te-IN-Chitra': 'te-IN-ShrutiNeural',
    'th-TH-Pattara': 'th-TH-NiwatNeural',
    'tr-TR-SedaRUS': 'tr-TR-EmelNeural',
    'vi-VN-An': 'vi-VN-NamMinhNeural',
};

export const DEFAULT_SAMPLE_VOICE_SCRIPT = 'Hey, nice to meet you. What do you think of my voice?';

export const LANGUAGE_TO_SAMPLE_SCRIPT_MAP: Record<string, string> = {
    multilingual: 'Hey, nice to meet you. What do you think of my voice?',
    english: 'Hey, nice to meet you. What do you think of my voice?',
    afrikaans: 'Haai, lekker om jou te ontmoet. Wat dink jy van my stem?',
    albanian: 'Hej, jam mirë që ju njohëm. Çfarë mendoni për zërin tim?',
    amharic: 'ሄይ፣ ስለተዋወቅን ደስ ብሎኛል። ስለ ድምፄ ምን ታስባለህ?',
    arabic: 'مرحبا انا سعيد للقائك. ما رأيك في صوتي؟',
    armenian: 'Հեյ, հաճելի է հանդիպել քեզ: Ի՞նչ կարծիքի ես իմ ձայնի մասին։',
    azerbaijani: 'Hey, sizinlə tanış olmaqdan məmnunam. Mənim səsim haqqında nə düşünürsünüz?',
    bangla: 'আপনার সাথে দেখা করতে হেই চমৎকার. আমার কন্ঠ সম্পর্কে আপনি কি মনে করেন?',
    basque: 'Aizu, pozten naiz zu ezagutzea. Zer iruditzen zaizu nire ahotsa?',
    bosnian: 'Hej, drago mi je. Šta misliš o mom glasu?',
    bulgarian: 'Хей, приятно ми е да се запознаем. Какво мислиш за гласа ми?',
    burmese: 'ဟေး တွေ့ရတာဝမ်းသာပါတယ်။ ငါ့အသံကို မင်းဘယ်လိုထင်လဲ။',
    catalan: 'Ei, un plaer conèixer-te. Què et sembla la meva veu?',
    chinese: '你好，很高兴遇到你。你觉得我的声音怎么样？',
    'chinese simplified': '你好，很高兴遇到你。你觉得我的声音怎么样？',
    'chinese traditional': '你好，很高興遇到你。你覺得我的聲音怎麼樣？',
    croatian: 'Hej, drago mi je. Što misliš o mom glasu?',
    czech: 'Ahoj, rád tě poznávám. Co si myslíš o mém hlase?',
    danish: 'Hej, rart at møde dig. Hvad synes du om min stemme?',
    dutch: 'Hallo leuk je te ontmoeten. Wat vind je van mijn stem?',
    estonian: 'Tere, meeldiv tutvuda. Mis sa mu häälest arvad?',
    filipino: 'Ikinagagalak kong makilala ka. Anong tingin mo sa boses ko?',
    finnish: 'Hei hauska tavata. Mitä mieltä olet äänestäni?',
    french: "Bonjour, enchanté de faire votre connaissance. Qu'est ce que vous pensez de ma voix?",
    galician: 'Ola, encantado de coñecerte. Que opinas da miña voz?',
    georgian: 'ჰეი, სასიამოვნოა თქვენი გაცნობა. რას ფიქრობ ჩემს ხმაზე?',
    german: 'Hey, freut mich dich kennen zu lernen. Was denkst du über meine Stimme?',
    greek: 'Ει Χαίρομαι που σε γνωρίζω. Τι γνώμη έχετε για τη φωνή μου;',
    gujarati: 'અરે, તમને મળીને આનંદ થયો. તમે મારા અવાજ વિશે શું વિચારો છો?',
    hebrew: 'היי, נעים להכיר מה אתה חושב על הקול שלי?',
    hindi: 'अहो, तुमसे मिलकर बहुत अच्छा लगा। आप मेरी आवाज के बारे में क्या सोचते हैं?',
    hungarian: 'Szia, örülök, hogy megismertelek. mit gondolsz a hangomról?',
    icelandic: 'Hæ, gaman að hitta þig. Hvað finnst þér um röddina mína?',
    indonesian: 'Hei, senang bertemu denganmu. Bagaimana pendapat Anda tentang suara saya?',
    irish: 'Hey, deas bualadh leat. Cad a cheapann tú de mo ghuth?',
    italian: 'Ehi piacere di conoscerti. cosa ne pensi della mia voce?',
    japanese: 'やあ、初めまして。私の声についてどう思いますか？',
    javanese: 'Hey, seneng ketemu kowe. Piye menurutmu suaraku?',
    kannada: 'ಹಾಯ್, ನಿಮ್ಮನ್ನು ಭೇಟಿಯಾಗಲು ಸಂತೋಷವಾಗಿದೆ. ನನ್ನ ಧ್ವನಿಯ ಬಗ್ಗೆ ನಿಮ್ಮ ಅಭಿಪ್ರಾಯವೇನು?',
    kazakh: 'Эй, танысқаныма қуаныштымын. Менің дауысым туралы не ойлайсыз?',
    khmer: 'ហេ រីករាយដែលបានជួបអ្នក។ តើអ្នកយល់យ៉ាងណាចំពោះសំឡេងរបស់ខ្ញុំ?',
    korean: '이봐 만나서 반가워. 내 목소리에 대해 어떻게 생각하세요?',
    lao: 'Hey, ດີໃຈທີ່ໄດ້ພົບເຈົ້າ. ເຈົ້າຄິດແນວໃດກັບສຽງຂອງຂ້ອຍ?',
    latvian: 'Hei, prieks iepazīties. Ko tu domā par manu balsi?',
    lithuanian: 'Labas, malonu susipažinti. ka manai apie mano balsa?',
    macedonian: 'Еј, мило ми е што те запознав. Што мислите за мојот глас?',
    malay: 'Hey, senang berkenalan. Apa pendapat anda tentang suara saya?',
    malayalam: 'ഹായ്, നിങ്ങളെ കണ്ടതിൽ സന്തോഷം. എൻ്റെ ശബ്ദത്തെക്കുറിച്ച് നിങ്ങൾക്ക് എന്തു തോന്നുന്നു?',
    maltese: "Ħej, kuntent li niltaqa' miegħek. X'taħseb tal-vuċi tiegħi?",
    marathi: 'अहो, तुम्हाला भेटून आनंद झाला. माझ्या आवाजाबद्दल तुम्हाला काय वाटते?',
    mongolian: 'Хөөе, танилцсандаа таатай байна. Миний хоолойг юу гэж бодож байна?',
    nepali: 'हे, तिमीलाई भेटेर खुशी लाग्यो। तिमीलाई मेरो आवाज कस्तो लाग्छ?',
    norwegian: 'Hei hyggelig å møte deg. Hva synes du om stemmen min?',
    pashto: 'هو، ستاسو په لیدلو خوشحاله شوم. زما د غږ په اړه څه فکر کوئ؟',
    persian: 'سلام از آشنایی با شما خوشحالم در مورد صدای من چه نظری داری؟',
    polish: 'Cześć, miło Cię poznać. Co sądzisz o moim głosie?',
    portuguese: 'Ei prazer em conhecê-lo. O que você acha da minha voz?',
    romanian: 'Salut, imi pare bine sa te cunosc. Ce crezi despre vocea mea?',
    russian: 'Привет, приятно познакомиться. Что ты думаешь о моем голосе?',
    serbian: 'Хеј, лепо је што смо се срели. Шта мислиш о мом гласу?',
    sinhala: 'හේයි, ඔබව හමුවීම සතුටක්. මගේ හඬ ගැන ඔබ සිතන්නේ කුමක්ද?',
    slovak: 'Ahoj, rád ťa spoznávam. Čo si myslíš o mojom hlase?',
    slovenian: 'Hej, lepo te je spoznati. Kaj misliš o mojem glasu?',
    somali: 'Haye, waan ku faraxsanahay inaan kula kulmo. Maxaad u malayn codkayga?',
    spanish: 'Oye un placer conocerte. ¿Qué piensas de mi voz?',
    sundanese: 'Héy, wilujeng tepang. Kumaha saur anjeun sora kuring?',
    swahili: 'Hey, nimefurahi kukutana nawe. Una maoni gani kuhusu sauti yangu?',
    swedish: 'Hej trevligt att träffas. Vad tycker du om min röst?',
    tamil: 'ஐயா, உங்களை சந்தித்ததில் மகிழ்ச்சி. என் குரலைப் பற்றி நீங்கள் என்ன நினைக்கிறீர்கள்?',
    telugu: 'హే, మిమ్మల్ని కలవడం ఆనందంగా ఉంది. నా వాయిస్ గురించి మీరు ఏమనుకుంటున్నారు?',
    thai: 'เฮ้ยินดีที่ได้รู้จัก. คุณคิดอย่างไรกับเสียงของฉัน?',
    turkish: 'Hey tanıştığımıza memnun oldum. Sesim hakkında ne düşünüyorsun?',
    ukrianian: 'Гей, радий познайомитися. Що ти думаєш про мій голос?',
    urdu: 'اے. تم سے ملکر خوشی ہوئی. میری آواز کے بارے میں کیا خیال ہے؟',
    uzbek: "Hey, tanishganimdan xursandman. Mening ovozim haqida nima deb o'ylaysiz?",
    vietnamese: 'Này, rất vui được gặp bạn. Bạn nghĩ gì về giọng nói của tôi?',
    welsh: 'Hei, braf cwrdd â chi. Beth yw eich barn am fy llais?',
    zulu: 'Sawubona, ngiyajabula ukukwazi. Ucabangani ngezwi lami?',
};
